.link {
  color: var(--color-link);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.18em;
  border-radius: var(--radius-sm);
}

.link:hover {
  color: var(--color-link-hover);
  text-decoration-thickness: 2px;
}

.standalone {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  text-decoration: none;
  font-weight: var(--weight-medium);
}

.standalone:hover {
  text-decoration: underline;
  text-decoration-thickness: 1px;
}

.externalIcon {
  display: inline-block;
  margin-inline-start: 2px;
  vertical-align: -2px;
}
